<template>
  <div class="menu-selecrt-wrapper">
    <a-auto-complete
      class="certain-category-search"
      dropdownClassName="menu-search-dropdown"
      :dropdownMatchSelectWidth="false"
      :dropdownStyle="{width: '240px'}"
      style="width: 100%"
      placeholder="食材名称"
      optionLabelProp="text"
      @search='handleSearch'
      @select='handleSelect'
      :defaultValue='defaultValue'
    >
      <template slot="dataSource">
        <a-select-option
          v-for="item in dataSource"
          :key="item.food_Id.toString()"
          :text='item.food_Name'
        >
          <div class="selectItem">
            <div class="selectItem-text">
              <p>{{item.food_Name}}</p>
              <p style="color:#1890ff">{{item.food_Code}}</p>
            </div>
          </div>
        </a-select-option>
      </template>
    </a-auto-complete>
  </div>
</template>
<script>
import { GetFoodByName } from '@/apis/menu';

export default {
  data() {
    return {
      dataSource: [],
      prevTime: 0,
      selectedItem: []
    }
  },
  props: {
    defaultValue: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSearch(value) {
      if (new Date().getTime() - this.prevTime > 100) {
        this.prevTime = new Date().getTime()
        this.dataSource = []
        if (value) {
          GetFoodByName({
            search: value
          }).then(res => {
            this.dataSource = res.data.attribute
          })
        }
      }
    },
    handleSelect(value, option) {
      this.selectedItem = this.getSelectObj(value)
      this.$emit('select', this.selectedItem)
    },
    getSelectObj(key) {
      let retObjIndex = this.dataSource.findIndex((item) => {
        return item.food_Id.toString() === key
      })
      return this.dataSource[retObjIndex]
    }

  },
  created() {

  }
}
</script>
<style>
.menu-search-dropdown .ant-select-dropdown-menu-item {
  border-bottom: 1px solid #f6f6f6;
}

.menu-search-dropdown .ant-select-dropdown-menu {
  max-height: 300px;
}
</style>

<style lang="less" scoped>
.menu-selecrt-wrapper
  /deep/
  .certain-category-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input-suffix {
  right: 12px;
}
.menu-selecrt-wrapper /deep/ .certain-search-item-count {
  position: absolute;
  color: #999;
  right: 16px;
}
.menu-selecrt-wrapper
  /deep/
  .certain-category-search.ant-select-focused
  .certain-category-icon {
  color: #108ee9;
}
.menu-selecrt-wrapper /deep/ .certain-category-icon {
  color: #6e6e6e;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 16px;
}

.ant-select-dropdown-menu-item p {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
/* 下拉 */
.selectItem {
  display: flex;

  .selectItem-text {
    padding-left: 10px;
    p {
      padding: 0;
      margin: 0;
      line-height: 24px;
    }
  }
}
</style>
